/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { oneOf, bool, string } from 'prop-types';
import classNames from 'clsx';

import styles from './black-tie-icon.scss';

/**
 * This is the BlackTieIcon component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export default class BlackTieIcon extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    icon: string.isRequired,
    weight: oneOf(['bts', 'btb', 'btr']),
    small: bool,
    className: string,
  };

  static defaultProps = {
    weight: 'bts',
    small: false,
    className: null,
  };

  shouldComponentUpdate() {
    return false;
  }

  /**
   * Render BlackTieIcon.
   *
   * @return {Object}
   */
  render() {
    const { className, icon, weight, small } = this.props;

    const iconType = `bt-${icon}`;

    return (
      <i
        className={classNames(styles.wrapper, className, weight, iconType, {
          [styles.small]: small,
        })}
      />
    );
  }
}
